import type { Maybe } from '@adornis/base/utilTypes.js';
import { ID } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getByID } from '@adornis/baseql/operations/mongo.js';
import { Recipient } from '@adornis/mails/db/recipients.js';
import { Message } from '@adornis/mails/server/communication.js';
import { projectConfig } from '@chancenwerk/config.js';
import { raumIntensiveCourseStudentChangedEmail } from '@chancenwerk/server/mailTemplates.js';
import { chancenWerkMailer } from '@chancenwerk/server/mailer.js';
import { Student } from '../entities/Student.js';

export const sendRelevantChangeNotificationEmail = registerMutation({
  type: () => Boolean,
  operationName: 'sendRelevantChangeNotificationEmail',
  options: {},
  params: [
    { type: () => ID, name: 'studentID' },
    { type: () => String, name: 'oldSchuelertyp' },
    { type: () => String, name: 'newSchuelertyp' },
    { type: () => String, name: 'oldMitgliedschaft' },
    { type: () => String, name: 'newMitgliedschaft' },
  ],
  resolve:
    (
      studentID: string,
      oldSchuelertyp: Maybe<string>,
      newSchuelertyp: Maybe<string>,
      oldMitgliedschaft: Maybe<string>,
      newMitgliedschaft: Maybe<string>,
    ) =>
    async () => {
      const student = await getByID<typeof Student>(
        Student,
        studentID,
      )({ _id: 1, nachname: 1, vorname: 1, studentID: 1 });
      if (!student) {
        throw new Error(`Unable to find student with ID ${studentID}`);
      }
      const message = await Message.compose({
        subject: `Änderung ${student.vorname} ${student.nachname} (${student.studentID})`,
        html: raumIntensiveCourseStudentChangedEmail({
          student,
          link: `${projectConfig.get('RAUM_URL').slice(0, -1)}/edit/person/student/${student._id}`,
          schuelertyp: { old: oldSchuelertyp, new: newSchuelertyp },
          mitgliedschaft: { old: oldMitgliedschaft, new: newMitgliedschaft },
        }),
      });
      await chancenWerkMailer.sendMail(message, [new Recipient('intensivkursdigital@chancenwerk.org')]);
      return true;
    },
});
